<div class="main-container-flex">
    <!-- <div class="left-column" *ngIf="!compactView">
        <ngb-datepicker #dp [(ngModel)]="datetime" (dateSelect)="onDateSelection($event)"
            (select)="onDateSelection($event)" [firstDayOfWeek]="firstDayOfWeek"></ngb-datepicker>
        <ng-content select="[bottomLeft]">

        </ng-content>
    </div> -->
    <div class="left-column" *ngIf="!compactView">
        <div class="datepicker-wrap">
            <ngb-datepicker #dp [(ngModel)]="datetime" (dateSelect)="onDateSelection($event)"
                (select)="onDateSelection($event)" [firstDayOfWeek]="firstDayOfWeek">
            </ngb-datepicker>

            <!-- View: {{view}} -->
        </div>

        <div class="bottom-left-bar2">
            <ng-content select="[bottomLeft]"></ng-content>
        </div>
    </div>
    <div class="right-column">
        <div class="calendar-container-flex">

            <div class="calendar-top">
                <div class="button-container">
                    <button (click)="gotoToday()" class="btn btn-primary today" *ngIf="!compactView">Today</button>

                    <i class="fa fa-chevron-left nav-item" (click)="previous()" title="Previous {{view}}"></i>
                    <i class="fa fa-chevron-right nav-item" (click)="next()" title="Next {{view}}"></i>

                    <div class="date-display">{{ dateDisplay }}</div>

                    <div class="view-selection" *ngIf="!compactView && !mobileView">
                        <select [(ngModel)]="view" (ngModelChange)="viewChange($event)">
                            <option value="Day">Day</option>
                            <option value="Week">Week</option>
                            <option value="WorkWeek">Work Week</option>
                            <option value="Month">Month</option>
                        </select>
                    </div>
                    <div class="view-selection" *ngIf="compactView">
                        <button (click)="gotoCalendarClick.emit()" *ngIf="!mobileView" class="btn-sm btn-primary">View
                            Full
                            Calendar</button>
                        <button (click)="gotoCalendarClick.emit()" *ngIf="mobileView" class="btn-sm btn-primary">
                            <i class="fa fa-calendar" title="View Full Calendar"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div #calendarBody class="calendar-body">
                <app-calendar-month-view *ngIf="!hideCalendar && view === 'Month'" (eventClick)="onMonthViewEventClick($event)" [options]="monthViewOptions"
                    [events]="events"></app-calendar-month-view>
                <daypilot-calendar [config]="config" [events]="events" #calendar
                    *ngIf="!hideCalendar && view !== 'Month'"></daypilot-calendar>
            </div>
        </div>
        <div class="bottom-right-bar">
            <ng-content select="[bottomRight]"></ng-content>
        </div>
    </div>
</div>

<!-- Old layout before message with Month view
<div class="main-container-flex">


    <div class="left-column" *ngIf="!compactView">
        <ngb-datepicker #dp [(ngModel)]="datetime" (dateSelect)="onDateSelection($event)"
            (select)="onDateSelection($event)" [firstDayOfWeek]="firstDayOfWeek"></ngb-datepicker>
        <ng-content select="[bottomLeft]">

        </ng-content>
    </div>
    <div class="right-column">
        <div class="calendar-container-flex">

            <div class="calendar-top">
                <div class="button-container">
                    <button (click)="gotoToday()" class="btn btn-primary today" *ngIf="!compactView">Today</button>

                    <i class="fa fa-chevron-left nav-item" (click)="previous()" title="Previous {{view}}"></i>
                    <i class="fa fa-chevron-right nav-item" (click)="next()" title="Next {{view}}"></i>

                    <div class="date-display">{{ dateDisplay }}</div>

                    <div class="view-selection" *ngIf="!compactView && !mobileView">
                        <select [(ngModel)]="view" (ngModelChange)="viewChange($event)">
                            <option value="Day">Day</option>
                            <option value="Week">Week</option>
                            <option value="WorkWeek">Work Week</option>
                            <option value="Month">Month</option>
                        </select>
                    </div>
                    <div class="view-selection" *ngIf="compactView">
                        <button (click)="gotoCalendarClick.emit()" *ngIf="!mobileView" class="btn-sm btn-primary">View
                            Full
                            Calendar</button>
                        <button (click)="gotoCalendarClick.emit()" *ngIf="mobileView" class="btn-sm btn-primary">
                            <i class="fa fa-calendar" title="View Full Calendar"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div #calendarBody class="calendar-body">
                <app-calendar-month-view *ngIf="!hideCalendar && view === 'Month'" [config]="config"
                    [events]="events"></app-calendar-month-view>
                <daypilot-calendar [config]="config" [events]="events" #calendar
                    *ngIf="!hideCalendar && view !== 'Month'"></daypilot-calendar>
            </div>
        </div>
        <ng-content select="[bottomRight]">

        </ng-content>
    </div>
</div> -->